import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_MUTED_COLOR,
  NOTE_PREVIEW_SIGNATURE_HEIGHT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewSignatureInfo } from "../note-preview-types";

export interface ReportSignatureBlockProps {
  signature: NotePreviewSignatureInfo;
}

const ReportSignatureBlock = ({ signature }: ReportSignatureBlockProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-end",
      gap: 32,
      marginTop: 28,
      fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
      color: NOTE_PREVIEW_TEXT_COLOR,
      breakInside: "avoid",
    }}
  >
    <div>
      <div style={{ height: NOTE_PREVIEW_SIGNATURE_HEIGHT_PX }}>
        {signature.image && (
          <img
            src={signature.image}
            alt={signature.signerName}
            style={{ height: "100%", objectFit: "contain" }}
          />
        )}
      </div>
      <div style={{ fontWeight: 700 }}>{signature.signerName}</div>
      <div style={{ color: NOTE_PREVIEW_MUTED_COLOR }}>{signature.role}</div>
    </div>
    <div>
      <div>{signature.signedAt}</div>
      <div style={{ fontWeight: 700 }}>{signature.signedAtLabel}</div>
    </div>
  </div>
);

export default ReportSignatureBlock;
